// NPM Imports
import React, { useContext, useEffect } from 'react'
import toast, { Toaster } from 'react-hot-toast'
// Quote Context
import { useQuoteContext } from '../../hooks/useQuoteContext'
// Component Imports
import Spacer from './Spacer'
// JS Imports
// Asset Imports

export default function Banner() {
   const state = useQuoteContext()

   let banner
   for (let item in state.pricebooks) {
      if (state.pricebooks[item]['value'] == state.pricebookId) {
         banner = state.pricebooks[item]['banner']
         break
      }
   }

   if (banner != null && banner != undefined && banner != '')
      return (
         <>
            <Spacer extraClassNames='bg-white'></Spacer>
            <div
               className='text-center sticky-top bg-white'
               dangerouslySetInnerHTML={{ __html: banner }}
            ></div>
            <Spacer extraClassNames='bg-white'></Spacer>
         </>
      )
}
